<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
  <form class="kt-form w-webkit-fill-available" [formGroup]="form">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'Import Dialog Popup Assignment' }}</h5>
        <span class="modal-x-button" (click)="onClose()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>

      <div class="modal-body">
        <div class="col-md-12">
          <div class="col-12 form-group row">
            <label class="col-4 kt-form__label col-form-label">{{ 'Dialog Popup' }} <span class="text-danger">*</span></label>
            <div class="col-8 kt-form__control px-0">
              <kt-dropdown-wo-lazyload
                [form]="form"
                [dropdownList]="popupsDropdown"
                [dropdownSettings]="popupsDropdownSettings"
                [formName]="'popup_id'"
                [selectionAttributes]="'id'"
                [selectedItems]="selectedPopup"
                (selectedItemsChanged)="onSelectedPopupChange($event)"
                [ngClass]="{'is-invalid': checkValidation && form.controls.popup_id.errors }">
              </kt-dropdown-wo-lazyload>
            </div>
          </div>

          <div class="col-12 form-group row">
            <label class="col-4 kt-form__label col-form-label">{{ 'Members' }} <span class="text-danger">*</span></label>
            <label class="col-2 btn btn-default btn-sm kt-form__control" [ngClass]="loading ? 'disabled' : ''">
              <span>{{ 'Import File' }}</span>
              <input type="file" hidden accept=".csv" (change)="onFileSelected($event)" [disabled]="loading" #fileInput>
            </label>
            <label class="col-6 kt-form__label col-form-label" *ngIf="selectedFile">{{ selectedFile.name }}</label>
          </div>

          <div class="col-12 row">
            <label class="col-4"></label>
            <div class="col-8 pl-0"><i class="fa fa-file-csv"></i><a href="assets/ExampleImportDialogPopup.csv" target="_blank" download="ExampleImportDialogPopup.csv"> {{ 'Download Template' }}</a></div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="col spinner-wrapper" *ngIf="loading">
          <mat-spinner [diameter]="15" class="mr-2"></mat-spinner>
          <p>{{ 'Importing... Please Wait' }}</p>
        </div>
        <button type="button" class="btn btn-secondary" (click)="onClose()"><i class="fas fa-ban"></i>{{ 'Close' }}</button>
        <kt-submit-button [buttonLoading]="loading" [isDisabled]="!canImport" (confirmed)="onImport()"></kt-submit-button>
      </div>
    </div>
  </form>
</div>
